export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";

export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGOUT = "USER_LOGOUT";

export const SAVE_ALL_HIGHLIGHTS = "SAVE_ALL_HIGHLIGHTS";
export const RESET_ALL_HIGHLIGHTS_DATA = "RESET_ALL_HIGHLIGHTS_DATA";

export const SAVE_ALL_FACILITIES = "SAVE_ALL_FACILITIES";
export const RESET_ALL_FACILITIES_DATA = "RESET_ALL_FACILITIES_DATA";

export const SAVE_ALL_BOOKINGS = "SAVE_ALL_BOOKINGS";
export const RESET_ALL_BOOKINGS = "RESET_ALL_BOOKINGS";

export const SAVE_ALL_ROOMS_LIST = "SAVE_ALL_ROOMS_LIST";
export const RESET_ALL_ROOMS_LIST = "RESET_ALL_ROOMS_LIST";

export const SAVE_USER_GAMES = "SAVE_USER_GAMES";
export const RESET_USER_GAMES = "RESET_USER_GAMES";

export const SAVE_USER_DETAILS = "SAVE_USER_DETAILS";
export const RESET_USER_DETAILS = "RESET_USER_DETAILS";

export const SAVE_USER_GAME = "SAVE_USER_GAME";
export const RESET_USER_GAME = "RESET_USER_GAME";

export const SAVE_USER_GROUPS = "SAVE_USER_GROUPS";
export const RESET_USER_GROUPS = "RESET_USER_GROUPS";

export const SAVE_PUBLIC_GROUPS = "SAVE_PUBLIC_GROUPS";
export const RESET_PUBLIC_GROUPS = "RESET_PUBLIC_GROUPS";

export const SAVE_USER_CARDS = "SAVE_USER_CARDS";
export const RESET_USER_CARDS = "RESET_USER_CARDS";

export const SAVE_ADS = 'SAVE_ADS';
export const RESET_ADS = 'RESET_ADS'

